/*
 * $Id:: DrawerSidebar.js 2020/11/11 12:46 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React from 'react';

import { IconButton, Drawer } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import MenuIcon from '@material-ui/icons/Menu';

import Sidebar from '../Sidebar';

const useStyles = makeStyles((_theme) => ({
    menuButton: {
        marginRight: '10px',
        '& svg': {
            fill: 'black',
            opacity: '.54',
            width: '24px !important',
        },
        '&.MuiButtonBase-root': {
            margin: '0 20px 0 0',
        },
    },
    drawer: {},
}));

const DrawerSidebar = () => {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);

    const handleSidebarVisibility = () => {
        setOpen(!open);
    };

    return (
        <div>
            <IconButton color="inherit" aria-label="open drawer" onClick={handleSidebarVisibility} edge="start" className={classes.menuButton}>
                <MenuIcon />
            </IconButton>
            <Drawer className={classes.drawer} anchor="left" open={open} onClose={handleSidebarVisibility}>
                <Sidebar smallDevice={true} handleSidebarVisibility={handleSidebarVisibility} />
            </Drawer>
        </div>
    );
};

export default DrawerSidebar;
